/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProposalSummaryJustIncomePortfolioAssetSplit
 */
export interface ProposalSummaryJustIncomePortfolioAssetSplit {
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryJustIncomePortfolioAssetSplit
     */
    assetCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalSummaryJustIncomePortfolioAssetSplit
     */
    fundName: string;
    /**
     * 
     * @type {number}
     * @memberof ProposalSummaryJustIncomePortfolioAssetSplit
     */
    splitPercentage?: number;
}

/**
 * Check if a given object implements the ProposalSummaryJustIncomePortfolioAssetSplit interface.
 */
export function instanceOfProposalSummaryJustIncomePortfolioAssetSplit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fundName" in value;

    return isInstance;
}

export function ProposalSummaryJustIncomePortfolioAssetSplitFromJSON(json: any): ProposalSummaryJustIncomePortfolioAssetSplit {
    return ProposalSummaryJustIncomePortfolioAssetSplitFromJSONTyped(json, false);
}

export function ProposalSummaryJustIncomePortfolioAssetSplitFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalSummaryJustIncomePortfolioAssetSplit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assetCode': !exists(json, 'AssetCode') ? undefined : json['AssetCode'],
        'fundName': json['FundName'],
        'splitPercentage': !exists(json, 'SplitPercentage') ? undefined : json['SplitPercentage'],
    };
}

export function ProposalSummaryJustIncomePortfolioAssetSplitToJSON(value?: ProposalSummaryJustIncomePortfolioAssetSplit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AssetCode': value.assetCode,
        'FundName': value.fundName,
        'SplitPercentage': value.splitPercentage,
    };
}

